import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "display": "block",
    "position": "relative",
    "width": "100%"
  }
};
import { reactive, ref, watch } from 'vue';
import { useProjectFormStore } from '@/stores';
import { DictionarySelect, modal } from '@/share/components';
import dayjs from 'dayjs';
export default {
  __name: 'project-form',
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const {
      formData,
      saveForm,
      resetForm
    } = useProjectFormStore();
    watch(() => [formData.startDate, formData.endDate], val => {
      const [startDate = '', endDate = ''] = val || [];
      if (!startDate || !endDate) return;
      const tStartDate = dayjs(startDate);
      const tEndDate = dayjs(endDate);
      if (!tStartDate.isValid() || !tEndDate.isValid()) return;
      formData.timeLimit = tEndDate.diff(tStartDate, 'year');
    });
    const validate = () => {
      return new Promise(resolve => {
        if (!formRef.value) {
          return resolve(false);
        }
        formRef.value.validate().then(data => resolve(data)).catch(() => {
          const els = document.getElementsByClassName('ant-form-item-has-error');
          if (els && els.length > 0 && els[0].scrollIntoView) {
            els[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
          resolve(false);
        });
      });
    };
    const formRules = reactive({
      name: [{
        required: true,
        trigger: 'blur',
        message: '项目名称不能为空'
      }],
      code: [{
        required: true,
        trigger: 'blur',
        message: '项目编号不能为空'
      }]
    });
    const save = async () => {
      const valid = await validate();
      if (!valid) return false;
      const {
        error,
        id
      } = await saveForm(false);
      if (error) {
        modal.notification.error(error, '保存项目基本信息失败');
        return false;
      }
      modal.notification.success('项目基本信息保存成功', '保存项目基本信息');
      return {
        id
      };
    };
    __expose({
      validate,
      save,
      resetForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(formData),
        rules: formRules
      }, {
        default: _withCtx(() => [_createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "政府预算项目",
              name: "budgetItem"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).budgetItem,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => _unref(formData).budgetItem = $event),
                placeholder: "请输入项目名称"
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目名称",
              name: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).name,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => _unref(formData).name = $event),
                placeholder: "请输入项目名称"
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目编号",
              name: "code"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).code,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => _unref(formData).code = $event),
                placeholder: "请输入项目编号"
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "部门职责",
              name: "depDuty"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "部门职责",
                value: _unref(formData).depDuty,
                "onUpdate:value": _cache[3] || (_cache[3] = $event => _unref(formData).depDuty = $event),
                text: _unref(formData).depDutyName,
                "onUpdate:text": _cache[4] || (_cache[4] = $event => _unref(formData).depDutyName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "工作活动",
              name: "jobActivity"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "工作活动",
                value: _unref(formData).jobActivity,
                "onUpdate:value": _cache[5] || (_cache[5] = $event => _unref(formData).jobActivity = $event),
                text: _unref(formData).jobActivityName,
                "onUpdate:text": _cache[6] || (_cache[6] = $event => _unref(formData).jobActivityName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "jsMajor"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isMajor,
                "onUpdate:checked": _cache[7] || (_cache[7] = $event => _unref(formData).isMajor = $event)
              }, {
                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode("是否重大事项项目", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目性质",
              name: "nature"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "项目性质",
                value: _unref(formData).nature,
                "onUpdate:value": _cache[8] || (_cache[8] = $event => _unref(formData).nature = $event),
                text: _unref(formData).natureName,
                "onUpdate:text": _cache[9] || (_cache[9] = $event => _unref(formData).natureName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目类别",
              name: "projType"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "项目类别",
                value: _unref(formData).projType,
                "onUpdate:value": _cache[10] || (_cache[10] = $event => _unref(formData).projType = $event),
                text: _unref(formData).projTypeName,
                "onUpdate:text": _cache[11] || (_cache[11] = $event => _unref(formData).projTypeName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目确定主体",
              name: "mainstay"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "项目确认主体",
                value: _unref(formData).mainstay,
                "onUpdate:value": _cache[12] || (_cache[12] = $event => _unref(formData).mainstay = $event),
                text: _unref(formData).mainstayName,
                "onUpdate:text": _cache[13] || (_cache[13] = $event => _unref(formData).mainstayName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目期限（年）",
              name: "timeLimit"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input_number, {
                value: _unref(formData).timeLimit,
                "onUpdate:value": _cache[14] || (_cache[14] = $event => _unref(formData).timeLimit = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "起始日期",
              name: "startDate"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                value: _unref(formData).startDate,
                "onUpdate:value": _cache[15] || (_cache[15] = $event => _unref(formData).startDate = $event),
                "value-format": "YYYY-MM-DD",
                format: "YYYY-MM-DD"
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "截止日期",
              name: "endDate"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                value: _unref(formData).endDate,
                "onUpdate:value": _cache[16] || (_cache[16] = $event => _unref(formData).endDate = $event),
                "value-format": "YYYY-MM-DD",
                format: "YYYY-MM-DD"
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "支出类型",
              name: "disburseType"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "支出类型",
                value: _unref(formData).disburseType,
                "onUpdate:value": _cache[17] || (_cache[17] = $event => _unref(formData).disburseType = $event),
                text: _unref(formData).disburseTypeName,
                "onUpdate:text": _cache[18] || (_cache[18] = $event => _unref(formData).disburseTypeName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "去向单位",
              name: "destUnit"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "去向单位",
                value: _unref(formData).destUnit,
                "onUpdate:value": _cache[19] || (_cache[19] = $event => _unref(formData).destUnit = $event),
                text: _unref(formData).destUnitName,
                "onUpdate:text": _cache[20] || (_cache[20] = $event => _unref(formData).destUnitName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "资金构成",
              name: "fund"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).fund,
                "onUpdate:value": _cache[21] || (_cache[21] = $event => _unref(formData).fund = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "关联待细化项目",
              name: "detail"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_textarea, {
                value: _unref(formData).detail,
                "onUpdate:value": _cache[22] || (_cache[22] = $event => _unref(formData).detail = $event),
                "auto-size": {
                  minRows: 2,
                  maxRows: 4
                }
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "编报模版",
              name: "compTpl"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "编报模版",
                value: _unref(formData).compTpl,
                "onUpdate:value": _cache[23] || (_cache[23] = $event => _unref(formData).compTpl = $event),
                text: _unref(formData).compTplName,
                "onUpdate:text": _cache[24] || (_cache[24] = $event => _unref(formData).compTplName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目总额（元）",
              name: "total"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input_number, {
                value: _unref(formData).total,
                "onUpdate:value": _cache[25] || (_cache[25] = $event => _unref(formData).total = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "基只：社会投入资金（元）",
              name: "investment"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input_number, {
                value: _unref(formData).investment,
                "onUpdate:value": _cache[26] || (_cache[26] = $event => _unref(formData).investment = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目级次",
              name: "level"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "项目级次",
                value: _unref(formData).level,
                "onUpdate:value": _cache[27] || (_cache[27] = $event => _unref(formData).level = $event),
                text: _unref(formData).levelName,
                "onUpdate:text": _cache[28] || (_cache[28] = $event => _unref(formData).levelName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "系统项目类别",
              name: "sysProjType"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "系统项目类型",
                value: _unref(formData).sysProjType,
                "onUpdate:value": _cache[29] || (_cache[29] = $event => _unref(formData).sysProjType = $event),
                text: _unref(formData).sysProjTypeName,
                "onUpdate:text": _cache[30] || (_cache[30] = $event => _unref(formData).sysProjTypeName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "转移支付方式",
              name: "paymentType"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).paymentType,
                "onUpdate:value": _cache[31] || (_cache[31] = $event => _unref(formData).paymentType = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "分配方式",
              name: "distribution"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).distribution,
                "onUpdate:value": _cache[32] || (_cache[32] = $event => _unref(formData).distribution = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "资金管理处",
              name: "fundMgr"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "资金管理处",
                value: _unref(formData).fundMgr,
                "onUpdate:value": _cache[33] || (_cache[33] = $event => _unref(formData).fundMgr = $event),
                text: _unref(formData).fundMgrName,
                "onUpdate:text": _cache[34] || (_cache[34] = $event => _unref(formData).fundMgrName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "是否待分配项",
              name: "isPending"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isPending,
                "onUpdate:checked": _cache[35] || (_cache[35] = $event => _unref(formData).isPending = $event)
              }, {
                default: _withCtx(() => [...(_cache[53] || (_cache[53] = [_createTextVNode("是否待分配项", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "热点分类",
              name: "hotClass"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DictionarySelect), {
                cate: "热点分类",
                value: _unref(formData).hotClass,
                "onUpdate:value": _cache[36] || (_cache[36] = $event => _unref(formData).hotClass = $event),
                text: _unref(formData).hotClassName,
                "onUpdate:text": _cache[37] || (_cache[37] = $event => _unref(formData).hotClassName = $event)
              }, null, 8, ["value", "text"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "isNewly"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isNewly,
                "onUpdate:checked": _cache[38] || (_cache[38] = $event => _unref(formData).isNewly = $event)
              }, {
                default: _withCtx(() => [...(_cache[54] || (_cache[54] = [_createTextVNode("是否含新增资产", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "isCapital"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isCapital,
                "onUpdate:checked": _cache[39] || (_cache[39] = $event => _unref(formData).isCapital = $event)
              }, {
                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [_createTextVNode("是否基建项目", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "isResearch"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isResearch,
                "onUpdate:checked": _cache[40] || (_cache[40] = $event => _unref(formData).isResearch = $event)
              }, {
                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode("是否科研项目", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "isReview"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isReview,
                "onUpdate:checked": _cache[41] || (_cache[41] = $event => _unref(formData).isReview = $event)
              }, {
                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [_createTextVNode("是否评审项目", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "isInform"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isInform,
                "onUpdate:checked": _cache[42] || (_cache[42] = $event => _unref(formData).isInform = $event)
              }, {
                default: _withCtx(() => [...(_cache[58] || (_cache[58] = [_createTextVNode("是否信息化", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "is3PMode"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).is3PMode,
                "onUpdate:checked": _cache[43] || (_cache[43] = $event => _unref(formData).is3PMode = $event)
              }, {
                default: _withCtx(() => [...(_cache[59] || (_cache[59] = [_createTextVNode("是否适用PPP模式", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "isSpecial"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isSpecial,
                "onUpdate:checked": _cache[44] || (_cache[44] = $event => _unref(formData).isSpecial = $event)
              }, {
                default: _withCtx(() => [...(_cache[60] || (_cache[60] = [_createTextVNode("是否专项债券项目", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "",
              name: "isInterest"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: _unref(formData).isInterest,
                "onUpdate:checked": _cache[45] || (_cache[45] = $event => _unref(formData).isInterest = $event)
              }, {
                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [_createTextVNode("是否还本付息项目", -1)]))]),
                _: 1
              }, 8, ["checked"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "债券编码",
              name: "bondCode"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).bondCode,
                "onUpdate:value": _cache[46] || (_cache[46] = $event => _unref(formData).bondCode = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "联系人",
              name: "contactPer"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).contactPer,
                "onUpdate:value": _cache[47] || (_cache[47] = $event => _unref(formData).contactPer = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "办公电话",
              name: "contactTel"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).contactTel,
                "onUpdate:value": _cache[48] || (_cache[48] = $event => _unref(formData).contactTel = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "手机号",
              name: "mobile"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: _unref(formData).mobile,
                "onUpdate:value": _cache[49] || (_cache[49] = $event => _unref(formData).mobile = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目描述",
              name: "desc"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_textarea, {
                value: _unref(formData).desc,
                "onUpdate:value": _cache[50] || (_cache[50] = $event => _unref(formData).desc = $event),
                "auto-size": {
                  minRows: 3,
                  maxRows: 6
                }
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "备注",
              name: "remark"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_textarea, {
                value: _unref(formData).remark,
                "onUpdate:value": _cache[51] || (_cache[51] = $event => _unref(formData).remark = $event),
                "auto-size": {
                  minRows: 2,
                  maxRows: 4
                }
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
};